export default {"src":"/_next/static/media/cyber-security.b029d1fb.svg","height":564,"width":579,"blurWidth":0,"blurHeight":0};